import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import DropdownTableCellEdit from 'components/organisms/TableCellEdits/DropdownTableCellEdit/DropdownTableCellEdit';

const StyledTeamRelevancyTableCellEdit = styled(DropdownTableCellEdit)`
  ${ComponentStyles}
`;

StyledTeamRelevancyTableCellEdit.propTypes = {
  theme: PropTypes.object
};

export default StyledTeamRelevancyTableCellEdit;
